<template>
  <div class="specifications-documentation-tab">
    <div class="text-h6 q-mb-md">Design Specifications</div>

    <div class="row q-col-gutter-md">
      <div class="col-12 col-md-6">
        <q-card flat bordered>
          <q-card-section>
            <div class="text-subtitle2 q-mb-sm">Performance Data</div>

            <q-input
              :model-value="modelValue.specifications?.design_cfm"
              label="Design Airflow (l/s)"
              outlined
              dense
              class="q-mb-sm"
              @update:model-value="updateField('design_cfm', $event)"
            />

            <q-input
              :model-value="modelValue.specifications?.fan_bhp"
              label="Fan BHP"
              outlined
              dense
              class="q-mb-sm"
              @update:model-value="updateField('fan_bhp', $event)"
            />

            <q-input
              :model-value="modelValue.specifications?.cooling_capacity"
              label="Cooling Capacity (tons)"
              outlined
              dense
              class="q-mb-sm"
              @update:model-value="updateField('cooling_capacity', $event)"
            />

            <q-input
              :model-value="modelValue.specifications?.heating_capacity"
              label="Heating Capacity (BTU/hr)"
              outlined
              dense
              @update:model-value="updateField('heating_capacity', $event)"
            />
          </q-card-section>
        </q-card>
      </div>

      <div class="col-12 col-md-6">
        <q-card flat bordered>
          <q-card-section>
            <div class="text-subtitle2 q-mb-sm">Commissioning Data</div>

            <q-input
              :model-value="modelValue.specifications?.test_date"
              label="Last Test & Balance Date"
              type="date"
              outlined
              dense
              class="q-mb-sm"
              @update:model-value="updateField('test_date', $event)"
            />

            <q-input
              :model-value="modelValue.specifications?.measured_cfm"
              label="Measured Airflow (l/s)"
              outlined
              dense
              class="q-mb-sm"
              @update:model-value="updateField('measured_cfm', $event)"
            />

            <q-input
              :model-value="modelValue.specifications?.measured_static"
              label="Measured Static Pressure"
              outlined
              dense
              class="q-mb-sm"
              @update:model-value="updateField('measured_static', $event)"
            />

            <q-input
              :model-value="modelValue.specifications?.balancing_contractor"
              label="Balancing Contractor"
              outlined
              dense
              @update:model-value="updateField('balancing_contractor', $event)"
            />
          </q-card-section>
        </q-card>
      </div>
    </div>

    <q-card flat bordered class="q-mt-md">
      <q-card-section>
        <q-input
          :model-value="modelValue.specifications?.commissioning_notes"
          label="Commissioning Notes"
          type="textarea"
          outlined
          rows="4"
          placeholder="Any additional commissioning notes, issues found, corrections made..."
          @update:model-value="updateField('commissioning_notes', $event)"
        />
      </q-card-section>
    </q-card>
  </div>
</template>

<script setup>
/**
 * Specifications Documentation Tab Component
 *
 * Displays form for documenting design specifications and commissioning data
 */

  const props = defineProps({
    modelValue: {
      type: Object,
      required: true,
      default: () => ({
        specifications: {
          design_cfm: '',
          fan_bhp: '',
          cooling_capacity: '',
          heating_capacity: '',
          test_date: '',
          measured_cfm: '',
          measured_static: '',
          balancing_contractor: '',
          commissioning_notes: '',
        },
      }),
    },
  });

  const emit = defineEmits(['update:specification']);

  function updateField(field, value) {
    emit('update:specification', { field, value });
  }
</script>

<style scoped>
.specifications-documentation-tab {
  height: 100%;
}
</style>
